import { t } from '@if/core/i18n'
import { EPaymentFrequency, EProvince, getEProvinceList } from '@if/core/types'
import * as yup from '@if/core/yup'
import { ETerms, ETermsList } from '@src/types/Constants'

export const CalculatorSchema = yup.object().shape({
  stateIso: yup.mixed<EProvince>().oneOf(getEProvinceList()),
  frequency: yup
    .mixed<EPaymentFrequency>()
    .oneOf([EPaymentFrequency.Monthly, EPaymentFrequency.BiWeekly], () => t('common.errors.invalidFrequency')),
  terms: yup.mixed<ETerms>().oneOf(ETermsList, () => t('common.errors.invalidTerm')),

  amountRequested: yup
    .integer()
    .min(750, () => t('common.errors.minimumAmount', { min: 750 }))
    .max(25000, () => t('common.errors.maximumAmount', { max: 25000 }))
    .required(),
})

export type CalculatorSchemaType = yup.InferSubmit<typeof CalculatorSchema>
